module.exports = __webpack_public_path__ + "img/verified-secondary.b98cd470.svg";